import { httpService } from "@/services/http.service"
import { Pagination } from "@/models/pagination"
import Department from "@/models/department"

const state = {
  list: Pagination.prototype.createEmpty()
}

const actions = {
  getAll: async ({ commit }, options) => {
    const response = await httpService.get("department", { params: options })
    commit("SET_DEPARTMENTS", { data: response.data.data, options })
  },
  get: async (context, id) => {
    const response = await httpService.get(`department/${id}`)
    return new Department(response.data.data)
  }
}

const mutations = {
  SET_DEPARTMENTS: (state, payload) => {
    const departmentsPagination = new Pagination(payload.data, "departments/getAll", payload.options)
    departmentsPagination.result = departmentsPagination.result.map((_department) => new Department(_department))
    state.list = departmentsPagination
  },
  CLEAR: (state) => {
    state.list = Pagination.prototype.createEmpty()
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
